export interface ClothingItemNameKeyMap {
  [normalizedName: string]: string;
}

export const CLOTHING_ITEM_NAME_KEYS: ClothingItemNameKeyMap = {
  'зимняя обувь': 'CLOTHING_ITEM_NAME_WINTER_SHOES',
  'зимняя куртка': 'CLOTHING_ITEM_NAME_WINTER_JACKET',
  'зимняя шапка': 'CLOTHING_ITEM_NAME_WINTER_HAT',
  'летняя обувь': 'CLOTHING_ITEM_NAME_SUMMER_SHOES',
  'летняя кепка': 'CLOTHING_ITEM_NAME_SUMMER_CAP',
  'слипоны': 'CLOTHING_ITEM_NAME_SLIP_ONS',
  'майка': 'CLOTHING_ITEM_NAME_TANK_TOP',
  'термобелье': 'CLOTHING_ITEM_NAME_THERMAL_UNDERWEAR',
  'лонгслив': 'CLOTHING_ITEM_NAME_LONGSLEEVE',
  'толстовка': 'CLOTHING_ITEM_NAME_LONGSLEEVE',
  'рабочий костюм': 'CLOTHING_ITEM_NAME_WORK_SUIT',
  'джинсовая куртка': 'CLOTHING_ITEM_NAME_DENIM_JACKET'
};

export function resolveClothingItemNameKey(value: string): string {
  if (!value) {
    return '';
  }

  var normalizedName = normalizeClothingItemName(value);
  return CLOTHING_ITEM_NAME_KEYS[normalizedName] || value;
}

export function normalizeClothingItemName(value: string): string {
  return value
    .toString()
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/ё/g, 'е');
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/clothing-item-name-key.helper.ts